export default __webpack_public_path__ + "static/media/toolkit.87a73b6b.svg";